import html from '../assets/icons/html.svg';
import bootstrap from '../assets/icons/bootstrap.svg';
import css from '../assets/icons/css.svg';
import git from '../assets/icons/git.svg';
import typescript from '../assets/icons/typescript.svg';
import sass from '../assets/icons/sass.svg';
import tailwind from '../assets/icons/tailwind.svg';
import react from '../assets/icons/react.svg';
import javascript from '../assets/icons/javascript.svg';
import php from '../assets/icons/php.svg';
import nodejs from '../assets/icons/nodejs.svg';
import python from '../assets/icons/python.svg';

const Languagues={
  html:html,
  bootstrap:bootstrap,
  css:css,
  git:git,
  typescript:typescript,
  sass:sass,
  tailwind:tailwind,
  react:react,
  javascript:javascript,
  php:php,
  nodejs:nodejs,
  python:python,
};

export {Languagues};